import React from "react";
import { X } from "lucide-react";

const Modal = ({ title, onClose, children, footer, maxWidth = "max-w-xl" }) => (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className={`bg-white rounded-2xl shadow-2xl w-full ${maxWidth}`}>
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
        <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100">
          <X className="h-4 w-4 text-gray-500" />
        </button>
      </div>
      <div className="px-4 py-3 space-y-4">{children}</div>
      {footer && (
        <div className="flex justify-end gap-2 px-4 py-3 border-t border-gray-100">
          {footer}
        </div>
      )}
    </div>
  </div>
);

export default Modal;
